import { OutsideClickHandler, Transition } from "ct-design";
import { Container } from "components/ct-design";
import { createPortal } from "react-dom";
import "./style.scss";
import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import SidesheetShimmer from "./Shimmer";
import { isWindowPresent } from "src/utils/browserHelpers";

interface SideSheetProps {
  direction: "left" | "right" | "up" | "down";
  open: boolean;
  timeout?: number;
  children: ReactNode;
  width?: string;
  loading?: boolean;
  onClose?: () => void;
}
const SideSheet: FunctionComponent<SideSheetProps> = (props) => {
  const {
    direction = "right",
    open,
    timeout = 350,
    children,
    width = "617px",
    loading = false,
    onClose = () => {},
  } = props;

  //This is to maintain the animation on oepning and closing
  const [localOpenState, setLocalOpenState] = useState(false);

  const MODAL_OPEN_CLASS = "body--modal-open";

  useEffect(() => {
    const overlayPressent = document.querySelector(".body--modal-open");

    if (!open && overlayPressent) {
      document.body.classList.remove(MODAL_OPEN_CLASS);
    }
    if (open && isWindowPresent) {
      setLocalOpenState(open);
      document.body.classList.add(MODAL_OPEN_CLASS);
    }
    if (localOpenState && !open) {
      setTimeout(() => {
        setLocalOpenState(false);
      }, 400);
    }

    return () => {
      if (overlayPressent) document.body.classList.remove(MODAL_OPEN_CLASS);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return localOpenState && isWindowPresent
    ? createPortal(
        <Container
          className={`${
            direction === "left" ? "flex-end" : "flex-start"
          } overlay-bg p-fixed flex w-100p h-100p t-0 flex-middle z-100 c-h-100vh`}
        >
          <OutsideClickHandler onOutsideClick={onClose}>
            <Transition
              type="slide"
              slideDirection={direction}
              in={open}
              timeout={timeout}
            >
              <Container
                className="flex flex-column flex bg-neutral-100 h-100p bg-white p-relative"
                width={width}
              >
                {loading ? <SidesheetShimmer /> : children}
              </Container>
            </Transition>
          </OutsideClickHandler>
        </Container>,
        document.body
      )
    : null;
};

export default SideSheet;
